export function removePublicPrerender(root: HTMLElement): void {
  root.querySelector("[data-public-prerender]")?.remove();
}
